module.exports = __webpack_public_path__ + "img/sicepat.20a20f74.png";